export const INVENTORY_2D_API=process.env.REACT_APP_INVENTORY_2D_API;
export const INVENTORY_2D_API_ACCESS_KEY=process.env.REACT_APP_INVENTORY_2D_API_ACCESS_KEY;